import React from "react";
import { ChevronDown, RefreshCw } from "lucide-react";

// Shared field styling for the court-search forms (High Court, Supreme Court).
export const inputStyles =
  "h-10 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 placeholder-slate-400 outline-none transition-colors focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/30";

export const selectStyles = `${inputStyles} cursor-pointer appearance-none pr-9 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400`;

export const Field = ({ label, required = true, className = "", children }) => (
  <div className={className}>
    <label className="mb-1.5 block text-xs font-medium text-slate-600">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {children}
  </div>
);

// Footer tips such as "All fields marked * are required" describe the marker
// <Field> renders above, so their "*" gets the same red instead of inheriting
// the muted tip colour.
export const renderTip = (tip) =>
  tip.split("*").flatMap((part, i) =>
    i === 0
      ? [part]
      : [
          <span key={i} className="text-red-500">
            *
          </span>,
          part,
        ]
  );

// Selects lose their native arrow via appearance-none, so draw our own.
export const SelectShell = ({ children, busy = false }) => (
  <div className="relative">
    {children}
    {busy ? (
      <RefreshCw className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 animate-spin text-yellow-500" />
    ) : (
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
    )}
  </div>
);
